<div class="table-title">
    <ng-container>
        <span class="sectionTitle" stylePreference [textColor]="textColor"> {{ sectionTitle }} </span>
    </ng-container>
    <mat-icon class="edit-icon" (click)="editSectionTitle()" svgIcon="aumico-pattern-icon-edit-write"></mat-icon>
</div>
<div [class]="markerClass">
    <table *ngIf="data.length !== 0">
        <ng-container *ngFor="let row of header; let rowIndex = index">
            <thead *ngIf="row.rowType === 'TableHead'">
                <tr class="flex-row black-border-down big-row-min-height_plus-border-height">
                    <th
                        class="text header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="header-cell-text"> </span>
                    </th>
                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.g1oV }}
                        </span>
                    </th>
                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.g1a }}
                        </span>
                    </th>

                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.g1d }}
                        </span>
                    </th>

                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.g1t }}
                        </span>
                    </th>

                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.g1cV }}
                        </span>
                    </th>

                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.g2oV }}
                        </span>
                    </th>
                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.g2a }}
                        </span>
                    </th>

                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.g2d }}
                        </span>
                    </th>

                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.g2t }}
                        </span>
                    </th>

                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.g2cV }}
                        </span>
                    </th>

                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.aV }}
                        </span>
                    </th>

                    <th class="separator-column" stylePreference backgroundColor="white"></th>

                    <th
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        [backgroundColor]="backgroundColor"
                    >
                        <span class="content header-cell-text">
                            {{ row.cV }}
                        </span>
                    </th>

                    <th class="separator-column" stylePreference [backgroundColor]="backgroundColor"></th>

                    <th
                        *ngIf="!noPrevious"
                        class="value header-footer header-cell-container"
                        stylePreference
                        [textColor]="tableHeaderColor"
                        backgroundColor="white"
                    >
                        <span class="content header-cell-text">
                            {{ row.pV }}
                        </span>
                    </th>

                    <th *ngIf="!noPrevious" class="separator-column" stylePreference backgroundColor="white"></th>
                </tr>
            </thead>
        </ng-container>
        <tbody>
            <ng-container *ngFor="let row of data; let rowIndex = index">
                <tr
                    *ngIf="row.rowType === 'Row' || row.rowType === 'OptRow'"
                    class="flex-row big-row-min-height_plus-border-height"
                    [ngClass]="[
                        row.rowType === 'GroupTotal' ? 'total-row' : '',
                        row.isGroup ? 'group-row' : '',
                        row.rowType === 'OptRow' ? 'no-counter' : '',
                        row.rowType === 'Row' || row.rowType === 'OptRow' ? 'content-row' : '',
                        row.rowType !== 'GroupTotal' && !row.disableNumbering
                            ? 'counter-level-' + row.level
                            : 'indent-level-' + row.level
                    ]"
                >
                    <td class="text" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="pre content"></span>
                        <span class="content desc">{{ row.t }}</span>
                    </td>
                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g1oV }}
                        </span>
                    </td>
                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g1a }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g1d }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g1t }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g1cV }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g2oV }}
                        </span>
                    </td>
                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g2a }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g2d }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g2t }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g2cV }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="textColor" backgroundColor="white">
                        <span class="content">
                            {{ row.aV }}
                        </span>
                    </td>

                    <td class="separator-column" stylePreference backgroundColor="white"></td>

                    <td class="value" stylePreference [textColor]="textColor" [backgroundColor]="backgroundColor">
                        <span class="content">
                            {{ row.cV }}
                        </span>
                    </td>

                    <td class="separator-column" stylePreference [backgroundColor]="backgroundColor"></td>

                    <td
                        *ngIf="!noPrevious"
                        class="value"
                        stylePreference
                        [textColor]="textColor"
                        backgroundColor="white"
                    >
                        <span class="content">
                            {{ row.pV }}
                        </span>
                    </td>

                    <td *ngIf="!noPrevious" class="separator-column" stylePreference backgroundColor="white"></td>
                </tr>
                <tr
                    *ngIf="row.rowType === 'GroupTotal'"
                    class="flex-row big-row-min-height_plus-border-height"
                    [ngClass]="[
                        row.rowType === 'GroupTotal' ? 'total-row' : '',
                        row.isGroup ? 'group-row' : '',
                        row.rowType === 'OptRow' ? 'no-counter' : '',
                        row.rowType === 'Row' || row.rowType === 'OptRow' ? 'content-row' : '',
                        row.rowType !== 'GroupTotal' && !row.disableNumbering
                            ? 'counter-level-' + row.level
                            : 'indent-level-' + row.level
                    ]"
                >
                    <td class="text" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="pre content"></span>
                        <span class="content desc">{{ row.t }}</span>
                    </td>
                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g1oV }}
                        </span>
                    </td>
                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g1a }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g1d }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g1t }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g1cV }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g2oV }}
                        </span>
                    </td>
                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g2a }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g2d }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g2t }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.g2cV }}
                        </span>
                    </td>

                    <td class="value" stylePreference [textColor]="tableFooterColor" backgroundColor="white">
                        <span class="content">
                            {{ row.aV }}
                        </span>
                    </td>

                    <td class="separator-column" stylePreference backgroundColor="white"></td>

                    <td
                        class="value"
                        stylePreference
                        [textColor]="tableFooterColor"
                        [backgroundColor]="backgroundColor"
                    >
                        <span class="content">
                            {{ row.cV }}
                        </span>
                    </td>

                    <td class="separator-column" stylePreference [backgroundColor]="backgroundColor"></td>

                    <td
                        *ngIf="!noPrevious"
                        class="value"
                        stylePreference
                        [textColor]="tableFooterColor"
                        backgroundColor="white"
                    >
                        <span class="content">
                            {{ row.pV }}
                        </span>
                    </td>

                    <td *ngIf="!noPrevious" class="separator-column" stylePreference backgroundColor="white"></td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
